import { render } from "./uploadFilesV2.vue?vue&type=template&id=51c5d99f&scoped=true"
import script from "./uploadFilesV2.vue?vue&type=script&lang=js"
export * from "./uploadFilesV2.vue?vue&type=script&lang=js"

import "./uploadFilesV2.vue?vue&type=style&index=0&id=51c5d99f&scoped=true&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-51c5d99f"]])

export default __exports__